import { render, staticRenderFns } from "./registerForm.vue?vue&type=template&id=a58dcfdc&scoped=true"
import script from "./registerForm.vue?vue&type=script&lang=js"
export * from "./registerForm.vue?vue&type=script&lang=js"
import style0 from "./registerForm.vue?vue&type=style&index=0&id=a58dcfdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58dcfdc",
  null
  
)

export default component.exports